export default "__VITE_ASSET__BclWLQ9m__"